var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var collectionReducer = function (items, action) {
    switch (action.type) {
        case "INIT": {
            return __assign(__assign({}, items), action.item);
        }
        case "SET_STATIC": {
            return __assign(__assign({}, items), { static: action.item });
        }
        case "REMOVE_STATIC": {
            var updatedStatic = items.static.filter(function (staticItem) { return staticItem.id !== action.item.id; });
            return __assign(__assign({}, items), { static: updatedStatic });
        }
        case 'SET_DYNAMIC': {
            return __assign(__assign({}, items), { dynamic: action.item });
        }
        case 'REMOVE_DYNAMIC': {
            var updatedDynamic = items.dynamic.filter(function (dynamicItem) { return dynamicItem.id !== action.item.id; });
            return __assign(__assign({}, items), { dynamic: updatedDynamic });
        }
        default: {
            throw Error("CollectionReducer: Unhandled action type ".concat(action.type));
        }
    }
};
export default collectionReducer;
